<template>
  <inventoryProvidersList/>
</template>
<script>
import inventoryProvidersList from '@/components/modules/inventory/providers/list'
export default {
  name: 'inventoryProviders',
  components: {
    inventoryProvidersList
  }
}
</script>



// WEBPACK FOOTER //
// src/views/inventory/providers/list.vue